export enum WorkplaceType {
  Onsite = 'onsite',
  Remote = 'remote',
  Hybrid = 'hybrid',
}
